import React from "react";

import "./Section.css";

type PropsType = {
  title?: string;
  children?: any;
};

const Section = ({ title, children }: PropsType) => {
  return (
    <section className="oc-section lg:tw-rounded-tr-[32px]">
      {title && (
        <h1 className="oc-section-title tw-text-[30px] lg:tw-text-[35px] tw-pt-8 tw-pl-[2rem] lg:tw-pl-[3.5rem]">
          {title}
        </h1>
      )}
      {children && (
        <div className="oc-section-inner tw-py-5 tw-rounded-tr-[32px] lg:tw-p-10 lg:tw-mr-5">
          {children}
        </div>
      )}
    </section>
  );
};

export default Section;
